import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { useScrollLock } from "@utils/hooks/useScrollLock";

import { useThunkDispatch } from "@redux/dispatcher";
import { getFlyoutCategories } from "@redux/modules/value/flyoutCategories/flyoutCategories.selectors";
import * as HeaderModule from "@redux/modules/value/header/header.module";
import * as HeaderSelectors from "@redux/modules/value/header/header.selectors";

import { MenuProvider } from "@context/MenuContext";

import _FlyoutMenu from "./flyoutMenu.component";

type Props = {
    update: (Object: any) => void;
};

const FLYOUT_MENU_SCROLL_LOCK = "flyout-menu";

const FlyoutMenu = (props: Props) => {
    const dispatch = useThunkDispatch();
    const header = useSelector(HeaderSelectors.getHeader, shallowEqual);
    const flyoutCategories = useSelector(getFlyoutCategories);
    const { lock, unlock } = useScrollLock(FLYOUT_MENU_SCROLL_LOCK);

    const updateHeader = (changes: any) => {
        dispatch(HeaderModule.update(changes));
    };

    const options = {
        active: header?.flyoutActive,
    };

    useEffect(() => {
        const isOpen = !!header?.flyoutActive || !!header?.sidebarActive;
        (isOpen ? lock : unlock)();
    }, [header]);

    return (
        <MenuProvider>
            <_FlyoutMenu
                {...props}
                data={flyoutCategories}
                active={options.active}
                update={(overwrite?: boolean) => {
                    updateHeader({
                        flyoutActive:
                            overwrite !== undefined
                                ? overwrite
                                : !header?.flyoutActive,
                    });
                }}
            />
        </MenuProvider>
    );
};

export { FlyoutMenu };
